import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
}
export function Button({
  children,
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  return <motion.button animate={{
    scale: [1, 1.015, 1],
    boxShadow: ['0 0 20px rgba(37,99,235,0.3)', '0 0 30px rgba(37,99,235,0.5)', '0 0 20px rgba(37,99,235,0.3)']
  }} transition={{
    duration: 3,
    repeat: Infinity,
    ease: 'easeInOut'
  }} whileHover={{
    scale: 1.05,
    boxShadow: '0 0 45px rgba(37,99,235,0.8)',
    transition: {
      duration: 0.2
    }
  }} whileTap={{
    scale: 0.95
  }} className={`
        relative group overflow-hidden rounded-full font-bold text-base md:text-xl
        bg-brand-blue text-white py-3.5 px-6 md:py-5 md:px-10
        transition-colors duration-300 flex items-center justify-center gap-2
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} data-id="element-251">
      <span className="relative z-10 flex items-center gap-2" data-id="element-252">
        {children}
        <ChevronRight className="w-5 h-5 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform" data-id="element-253" />
      </span>
      <div className="absolute inset-0 bg-gradient-to-r from-brand-blueDark to-brand-blue opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-254" />
    </motion.button>;
}